import {CURRENCY} from './Config';

// Formate un montant pour affichage avec la devise configurée (cf. CURRENCY dans Config.js).
// `amount` est exprimé en UNITÉS entières de la devise (euros, DKK...), PAS en centimes :
// les champs API d'affichage (totalSejour, totalht, soldeApayer, prix) sont déjà en unités.
// Pour un montant en centimes (acompte, solde passerelle), diviser par 100 avant l'appel.
export function formatPrice(amount) {
    const value = Number(amount);
    if (!isFinite(value)) return '';
    return new Intl.NumberFormat(CURRENCY.locale, {
        style: 'currency',
        currency: CURRENCY.code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(value);
}
